<template>
	<div>
		<a-layout>
			<div class="content-header">
				<a-affix :offset-top="0" style="width: 100%;">
					<a-row type="flex" justify="space-between">
						<a-col span="12">
							<a-button-group>
								<a-button type="primary" v-has="'staff:info:save'"
									@click="$refs.addForm._show()">添加档案</a-button>
							</a-button-group>
						</a-col>
						<a-col span="12">
							<a-row type="flex" align="middle" justify="end" :gutter="3">
								<a-col span="12">
									<a-input v-model="param.keyword" allowClear search @pressEnter="getList()"
										@change="change" @on-clear="getList()" placeholder="关键词查询"></a-input>
								</a-col>
								<a-col span="6" v-if="getOrganId() <= 10000">
									<a-select v-model="param.organId" style="width:100%" @change="doRefresh">
										<a-select-option :value="0">所有单位</a-select-option>
										<a-select-option :value="organ.organId" v-for="(organ, index) in getOrganList()"
											:key="index">{{
																						organ.name }}</a-select-option>
									</a-select>
								</a-col>
							</a-row>
						</a-col>
					</a-row>
				</a-affix>
			</div>
		</a-layout>

		<a-table :columns="columns" :defaultExpandAllRows="true" :scroll="{ x: '100%' }" :pagination="false"
			:indentSize="25" :style="{ background: '#FFF' }" size="small" row-key="id" border :loading="loading"
			:data-source="data.records">
			<!-- 标题 -->
			<template slot-scope="row" slot="rowname">
				<a @click="$refs.detail.show(row)">{{ row.name }}</a>
			</template>
			<!-- 合同日期 -->
			<template slot-scope="row" slot="contract">
				<span>{{ row.contractStart }} 至 {{ row.contractEnd }}</span>
			</template>
			<!-- 是否发布 -->
			<template slot-scope="row" slot="issue">
				<a-tooltip :title="row.issue ? '是' : '否'">
					<template v-if="row.issue == true">
						<a-icon type="check-circle" style="color:#090" />
					</template>
					<template v-else>
						<a-icon type="stop" />
					</template>
				</a-tooltip>
			</template>
			<!--操作-->
			<template slot-scope="row" slot="action">
				<a-button-group shape="circle" size="small">
					<a-tooltip title="修改数据"><a-button v-has="'staff:info:save'" type="link" icon="edit"
							@click="$refs.addForm._show(row)"></a-button></a-tooltip>
					<a-tooltip title="删除数据"><a-button v-has="'staff:info:del'" type="link" icon="delete"
							@click="del(row.id)"></a-button></a-tooltip>
				</a-button-group>
			</template>
		</a-table>
		<a-row>
			<a-col span="12" offset="6" style="text-align: center; padding: 20px 0;">
				<a-pagination :defaultPageSize="param.limit" :total="data.total" @change="getNext"
					@showSizeChange="setLimit" :current="data.current" />
			</a-col>
		</a-row>
		<add-form ref="addForm" @success="doRefresh"></add-form>

		<detail ref="detail"></detail>
	</div>
</template>

<script>
import apiUtil from '@/common/apiUtil';
import utils from '@/common/utils';
import addForm from './components/addForm.vue';
import detail from './components/detail.vue';
export default {
	components: { addForm, detail },
	data() {
		return {
			data: {},
			loading: false,
			organList: apiUtil.getOrganList(),
			pageSize: 10,
			total: '',
			param: {
				current: 1,
				limit: 20,
				keyword: '',
				organId: apiUtil.getOrganId(''),
			},
			columns: [
				{ title: 'ID', dataIndex: 'id', width: 80, align: 'center' },
				{ title: '姓名', scopedSlots: { customRender: 'rowname' } },
				{ title: ' 部门', dataIndex: 'depName', width: 200, align: 'center' },
				{ title: '类型', dataIndex: 'staffType', width: 200, resizable: true, align: 'center' },
				{ title: '性别', dataIndex: 'sex', width: 160, resizable: true, align: 'center' },
				{ title: '手机号', dataIndex: 'phone', width: 160, resizable: true, align: 'center' },
				{ title: '职务', dataIndex: 'jobName', width: 200, resizable: true, align: 'dess' },
				{ title: '合同期限', scopedSlots: { customRender: 'contract' }, width: 200, align: 'center' },
				{ title: '操作', scopedSlots: { customRender: 'action' }, width: 120, align: 'center' }
			]
		};
	},
	mounted() {
		this.getList();
	},
	methods: {
		...apiUtil,
		// 获取数据
		getList() {
			this.loading = true;
			this.http
				.get('/platform/staff/info', this.param)
				.then(ret => {
					this.data = ret.data;
					this.total = data.total;
					this.param.current = data.current;
					this.loading = false;
				})
				.catch(err => {
					this.loading = false;
				});
		},
		change(e) {
			if (e.target.value == '') {
				this.getList();
			}
		},
		// 删除
		del(id) {
			this.utils.confirm('删除后无法恢复，是否确认?').then(() => {
				utils.showSpin();
				this.http.delete('/platform/staff/info/del/' + id).then(ret => {
					if (ret.code == 200) {
						this.utils.success('操作成功！').then(() => {
							this.getList();
							// console.log(1111);
						});
					}
				});
			});
		},
		// 筛选条件变化重新获取数据
		doRefresh() {
			this.param.current = 1;
			this.getList();
		},

		// 筛选单位
		filterOrgan(e) {
			this.param.organId = e;
		},
		//设置每页的显示条数
		setLimit(current, limit) {
			this.param.page = 1;
			this.param.limit = limit;
			this.getList();
		},
		//页码切换
		getNext(page) {
			this.param.page = page;
			this.getList();
		}
	}
};
</script>

<style></style>
